import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { analyticsApi } from "./service/analytics.service";
import { callsApi } from "./service/calls.service";
import { complianceApi } from "./service/compliance.service";
import { groupOnboardingApi } from "./service/groupOnboarding.service";
import { onboardingApi } from "./service/onboarding.service";
import { patientSyncApi } from "./service/patientSync.service";
import appStateSlice from "./slices/appStateSlice";
import authReducer from "./slices/authSlice";
import bannerReducer from "./slices/bannerSlice";
import clientSlice from "./slices/clientSlice";
import notesSlice from "./slices/notesSlice";
import recodingsReducer from "./slices/recordingsSlice";
import userReducer from "./slices/userSlice";

const store = configureStore({
  reducer: {
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [callsApi.reducerPath]: callsApi.reducer,
    [complianceApi.reducerPath]: complianceApi.reducer,
    [groupOnboardingApi.reducerPath]: groupOnboardingApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [patientSyncApi.reducerPath]: patientSyncApi.reducer,
    auth: authReducer,
    user: userReducer,
    recordings: recodingsReducer,
    appState: appStateSlice,
    notes: notesSlice,
    client: clientSlice,
    banner: bannerReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["recordings/setMediaRecorder"],
        ignoredPaths: ["recordings.mediaRecorder"],
      },
    }).concat(
      analyticsApi.middleware,
      callsApi.middleware,
      complianceApi.middleware,
      groupOnboardingApi.middleware,
      onboardingApi.middleware,
      patientSyncApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
